<template>
  <div class="container-fluid m-0 p-0" id="mmp">
    <MatrizMenu />
    <div class="pl-2 pr-2">
      <div class="box-body bg-light matriz-peligro-content col-md-12" style="padding: 0px 0px 0px 20px">
        <div class="collapse show" id="mmr-collapse">
          <form v-on:submit.prevent="formulario_acciones()">
            <div class="row">
              <div class="col-md-9 mt-2">
                <label class="color_letra" style="font-size: 14px">*Cliente
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Seleccione uno de los clientes con el que vinculará la matriz de peligros"></i>
                  </span>
                </label>
                <br />
                <v-select class="form-control form-control-md boton_texto" v-model="cliente"
                  @input="consultar_clientes_por_nombre" :options="clientes_iper" required></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label class="color_letra" style="font-size: 14px">Grupo de Exposicion Similar
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="El grupo de exposición similar es la agrupación de los clientes de acuerdo a su actividad económica principal">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="sector_cliente" type="text" disabled />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="color_letra mt-2" style="font-size: 14px">*Centro de Trabajo
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Indique el nombre del Centro de Trabajo al que va a realizar la matriz de peligros">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="centro_trabajo" type="text"
                  placeholder="Nombre del Centro de Trabajo" spellcheck="true" required />
              </div>
              <div class="col-md-2">
                <label class="color_letra mt-2" style="font-size: 14px">*Expuestos
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Indique a continuación el número de trabajadores objeto de la presente matriz de peligros, incluir trabajadores que están en descanso y/u otros turnos">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="numero_expuestos" type="number" min="0"
                  placeholder="N° de Expuestos" required />
              </div>
              <div class="col-md-2">
                <label class="color_letra mt-2" style="font-size: 14px">*Regional
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Seleccione a continuación la regional a la que pertenece el Centro de Trabajo"></i>
                  </span>
                </label>
                <select class="form-control form-control-sm boton_texto" id="regional" v-model="regional"
                  @change="departamento_select()" required>
                  <option value="" selected disabled>
                    Seleccione la regional
                  </option>
                  <option v-for="(reg, index) of lista_regionales" :key="index.reg">
                    {{ reg }}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="color_letra mt-2" style="font-size: 14px">*Departamento
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Seleccione a continuación el departamento al que pertenece el Centro de Trabajo">
                    </i>
                  </span>
                </label>
                <select class="form-control form-control-sm boton_texto" id="departamento" v-model="departamento"
                  @change="municipio_select()" required>
                  <option value="" selected disabled>
                    Seleccione el departamento
                  </option>
                  <option v-for="(dept, index) of lista_departamentos" :key="index.dept">
                    {{ dept }}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="color_letra mt-2" style="font-size: 14px">*Ciudad
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Seleccione a continuación la ciudad o muncipio al que pertencece el Centro de Trabajo">
                    </i>
                  </span>
                </label>
                <select class="form-control form-control-sm boton_texto" id="ciudad" v-model="municipio" required>
                  <option value="" selected disabled>
                    Seleccione la ciudad
                  </option>
                  <option v-for="(municipio, index) of lista_municipios" :key="index.municipio">
                    {{ municipio }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="color_letra mt-2" style="font-size: 14px">Dirección
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacione a continuación la dirección donde se ubica el Centro de Trabajo">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="direccion" type="text"
                  placeholder="Dirección del Centro de Trabajo" spellcheck="true" />
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-2" style="font-size: 14px">Ubicación GPS</label>
                <div class="row justify-content-md-center">
                  <div class="col-sm-3">
                    <button class="btn btn-sm gps font-weight-bold" type="button" @click="obtener_ubicacion">
                      Obtener
                    </button>
                  </div>
                  <div class="col-sm-9">
                    <input class="
                                form-control
                                form-control-sm
                                form-control
                                form-control-sm-sm
                                boton_texto
                              " v-model="coordenadas_encuesta" type="text" readonly />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="color_letra mt-2" style="font-size: 14px">*Contacto
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacione a continuación la persona contacto o representante de la empresa en el Centro de Trabajo con quien se coordinó la actividad de la matriz de peligros">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="nombre_contacto" type="text"
                  placeholder="Nombre de la persona" required readonly />
              </div>
              <div class="col-md-3">
                <label class="color_letra mt-2" style="font-size: 14px">*Cargo
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacione a continuación el cargo de la persona contacto con quien se coordinó la actividad de la matriz de peligros">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="cargo_contacto" type="text"
                  onchange="value=toTitleCase(this.value)" onkeyup="value=toTitleCase(this.value)"
                  placeholder="Cargo de la persona" required readonly />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="color_letra mt-2" style="font-size: 14px">*Correo Electrónico
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacione a continuación el correo del contacto del Centro de Trabajo con quien se coordinó la actividad de matriz de peligros">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="correo_contacto" type="email"
                  placeholder="Correo electrónico" required readonly />
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-2" style="font-size: 14px">*Celular/Teléfono
                  <span class="badge text-secondary">
                    <i class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Relacione a continuación un número telefónico del contacto del Centro de Trabajo con quien se coordinó la actividad de matriz de peligros">
                    </i>
                  </span>
                </label>
                <input class="form-control form-control-sm boton_texto" v-model="numero_contacto" type="number" min="1"
                  placeholder="Celular o teléfono" required readonly />
              </div>
              <div class="col-md-4">
                <label class="color_letra mt-2" style="font-size: 14px">*Fecha Matriz
                </label>
                <br />
                <a class="btn btn-sm btn_guardar btn-block mt-3" data-toggle="modal" data-target="#controlCambios"
                  type="button">
                  <i class="fas fa-calendar-alt"></i>
                </a>
              </div>
            </div>
            <div>
              <label class="color_letra" style="font-size: 12px">*Campos Obligatorios.</label>
            </div>
            <div class="row justify-content-center">
              <button class="btn btn-sm btn-form font-weight-bold" v-show="$store.state.msp_c_key" type="button"
                @click="terminar_centro_trabajo">
                TERMINAR MATRIZ DE PELIGROS
              </button>
              <button class="btn btn-sm btn-form font-weight-bold" v-if="$store.state.msp_c_key" type="submit">
                EDITAR
              </button>
              <button class="btn btn-sm btn-form font-weight-bold" v-else type="submit" :disabled="!priv_crear">
                GUARDAR
              </button>
            </div>
          </form>
        </div>
        <div class="d-flex align-items-end flex-column mr-1">
          <a data-toggle="collapse" data-target="#mmr-collapse" @click="collapsed = !collapsed" aria-expanded="false"
            aria-controls="collapseExample" style="cursor: pointer">
            <i :class="[collapsed ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- MODAL CONTROL DE CAMBIOS -->
    <div class="modal fade" id="controlCambios" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-header text-center" style="border: 0px">
            <h1 class="dato w-100 font-weight-bold" id="exampleModalLabel">
              Control de Cambios
            </h1>
            <button class="close" data-dismiss="modal" type="button" aria-label="Close">
              <span aria-hidden="true"><b>&times;</b></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="color_letra mb-2">Tipo de Cambio: *</label>
                <select class="form-control form-control-sm boton_texto mt-4"
                  v-model="controlCambioMatriz.controlCambios.tipoCambio" required>
                  <option disabled selected>Seleccione...</option>
                  <option value="Elaboración">Elaboración</option>
                  <option value="Actualizacción">Actualización</option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="color_letra mb-2">Fecha: *</label>
                <input class="form-control form-control-sm boton_texto" v-model="fechaCambio" type="date" required>
              </div>
              <div class="col-md-4">
                <label class="color_letra mb-2">Observación:</label>
                <textarea class="form-control form-control-sm boton_texto"
                  v-model="controlCambioMatriz.controlCambios.observacionCambio" placeholder="Observación"
                  autocomplete="on" spellcheck="true" required></textarea>
              </div>
            </div>
          </div>
          <div class="row justify-content-center pb-4">
            <button class="btn btn-sm btn-form font-weight-bold" data-dismiss="modal" type="button">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Mtm v-if="$store.state.msp_c_key" />
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, db } from "@/firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import MatrizMenu from "@/components/MatrizMenu.vue";
import Mtm from "@/components/Mtm.vue";

export default {
  name: "mmp",

  components: {
    MatrizMenu,
    Mtm,
  },

  data() {
    return {
      collapsed: true,
      // VARIABLES REGISTRO CENTRO DE TRABAJO
      cliente: "",
      sector_cliente: "",
      id_cliente_iper: "",
      centro_trabajo: "",
      numero_expuestos: null,
      regional: "",
      pais_trabajo: "Colombia",
      departamento: "",
      municipio: "",
      nombre_contacto: "",
      cargo_contacto: "",
      correo_contacto: "",
      numero_contacto: "",
      fecha_actualizado: "",
      direccion: "",
      clientes_iper: [],
      lista_regionales: [],
      regionales: null,
      lista_departamentos: [],
      lista_municipios: [],
      priv_crear: false,
      latitud_encuesta: "",
      longitud_encuesta: "",
      coordenadas_encuesta: "",
      // CONTROL DE CAMBIOS
      controlCambioMatriz: {
        controlCambios: {
          idControlCambio: "",
          tipoCambio: "",
          fechaCambio: "",
          observacionCambio: "",
          correoUsuario: "",
        },
        registro: {
          creacion: firebase.firestore.FieldValue.serverTimestamp(),
        },
      },
      fechaCambio: "",
    };
  },

  async created() {
    this.regional_select();
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    // VARIABLE THIS LISTA DE CLIENTES
    await this.cargar_clientes();
    if (this.$store.state.global_privilegio_matriz_peligro.crear) {
      this.priv_crear = true;
    }
    this.nombre_contacto = "Ángela Johana Gaitán López";
    this.cargo_contacto = "Gerente H&S";
    this.correo_contacto = "angela.gaitan@co.g4s.com";
    this.numero_contacto = 3212543320;
    this.controlCambioMatriz.controlCambios.correoUsuario = this.$store.state.email_session;

    let date = new Date();
    let output =
      String(date.getDate()).padStart(2, "0") +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      date.getFullYear();
    this.controlCambioMatriz.controlCambios.tipoCambio = "Elaboración";
    if (this.$store.state.msp_c_key) {
      this.consultar_matriz_peligros();
    }
  },

  methods: {
    // OBTENER COORDENADAS - REGISTRAR ENCUESTA
    obtener_ubicacion() {
      // LIMPIAR VARIABLES DE LONGITUD Y LATITUD
      this.latitud_encuesta = "";
      this.longitud_encuesta = "";
      this.coordenadas_encuesta = "";

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitud_encuesta = position.coords.latitude;
          this.longitud_encuesta = position.coords.longitude;
          this.coordenadas_encuesta =
            this.latitud_encuesta + ", " + this.longitud_encuesta;

          // MENSAJE DE GUARDADO
          Swal.fire({
            position: "center",
            icon: "success",
            background: "transparent",
            html:
              '<h4 style="color: rgb(255, 255, 255)">¡Ubicación obtenida correctamente!</h4>',
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
      } else {
        console.log("¡El navegador no soporta la geolocalización!");
      }
    },

    formulario_acciones() {
      if (this.$store.state.msp_c_key) {
        this.editar_centro_trabajo();
      } else if (this.priv_crear) {
        this.agregar_centro_trabajo();
      }
    },

    // FUNCIÓN PARA AGREGAR MATRIZ DE PELIGROS A LA BASE DE DATOS
    agregar_centro_trabajo() {
      if (this.fechaCambio == "") {
        Swal.fire("Fecha matriz vacia");
      } else {
        this.fechaCambio = this.fechaCambio.split("-");
        var newDate = new Date(
          this.fechaCambio[0],
          this.fechaCambio[1] - 1,
          this.fechaCambio[2]
        );

        let empresa = "G4S";
        const newCentroRef = db.collection("cliente_empresa").doc();
        const id = newCentroRef.id;
        (async () => {
          db.collection("cliente_empresa")
            .doc(id)
            .set({
              em_empresa: empresa,
              em_id_cliente_principal: this.id_cliente_iper,
              em_trabajo: this.centro_trabajo,
              em_num_trabajadores: this.numero_expuestos,
              em_sector: this.sector_cliente,
              em_pais: this.pais_trabajo,
              em_regional: this.regional,
              em_departamento: this.departamento,
              em_ciudad: this.municipio,
              em_registrado_por: this.$store.state.email_session,
              em_visita:
                this.$store.state.session_nombre +
                this.$store.state.session_apellido,
              em_fecha: firebase.firestore.FieldValue.serverTimestamp(),
              em_fecha_editado: newDate,
              em_responsable: this.nombre_contacto,
              em_cargo: this.cargo_contacto,
              em_correo_contacto: this.correo_contacto,
              em_numero_contacto: this.numero_contacto,
              em_direccion: this.direccion,
              em_activo: true,
              em_baja: true,
              em_nit: "",
              em_completo: true,
              em_gps: this.coordenadas_encuesta,
            })
            .then(() => { })
            .catch((error) => console.log("Error al guardar: ", error));
          // ALERTA GUARDADO
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Datos guardados correctamente.",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$store.state.n_max_expuestos = this.numero_expuestos;
          // CLIENTE EMPRESA
          this.$store.state.msp_c_key = id;
          // CLIENTE PRINCIPAL
          this.$store.state.msp_c_key_cliente_iper = this.id_cliente_iper;
          // FIN ALERTA GUARDADO
          this.control_cambio(id, newDate);
          this.limpiar_variables();
          const tap1 = document.querySelector("#mmp-tab");
          tap1.classList.remove("active");
          tap1.setAttribute("aria-selected", false);
          const tap2 = document.getElementById("msp-tab");
          tap2.setAttribute("aria-selected", true);
          this.$router.push("/seleccionar_proceso");
        })();
      }
    },

    // FUNCIÓN PARA EDITAR MATRIZ DE PELIGRO
    editar_centro_trabajo() {
    if(this.controlCambioMatriz.controlCambios.observacionCambio == ''){
      Swal.fire({
        title: "Datos incompletos en Fecha Matriz",
        icon: "warning",
        confirmButtonColor: "#EE8813",
        confirmButtonText: "Entendido"
      })
    } else{ 
      this.$store.state.msp_c_key_cliente_iper = this.id_cliente_iper;
      if (this.fechaCambio != "") {
        this.fechaCambio = this.fechaCambio.split("-");
        var fechaEditada = new Date(
          this.fechaCambio[0],
          this.fechaCambio[1] - 1,
          this.fechaCambio[2]
        );
      } else {
        var fechaEditada = this.fecha_actualizado;
      }
      // FUNCIÓN PARA EDITAR
      db.collection("cliente_empresa")
        .doc(this.$store.state.msp_c_key)
        .update({
          em_empresa: "G4S",
          em_id_cliente_principal: this.id_cliente_iper,
          em_trabajo: this.centro_trabajo,
          em_num_trabajadores: this.numero_expuestos,
          em_sector: this.sector_cliente,
          em_pais: this.pais_trabajo,
          em_regional: this.regional,
          em_departamento: this.departamento,
          em_ciudad: this.municipio,
          em_fecha_editado: fechaEditada,
          em_completo: true,
          em_responsable: this.nombre_contacto,
          em_cargo: this.cargo_contacto,
          em_correo_contacto: this.correo_contacto,
          em_numero_contacto: this.numero_contacto,
          em_direccion: this.direccion,
          em_baja: true,
          em_gps: this.coordenadas_encuesta,
        })
        .then(() => {
          // ACTUALIZAR MATRIZ RIESGO SI EXISTE, AGREGÁNDOLE id_cliente_iper
          db.collection("matriz_riesgo")
            .where("em_id_cliente", "==", this.$store.state.msp_c_key)
            .get()
            .then((querySnapshot) => {
              if (querySnapshot.docs.length > 0) {
                querySnapshot.forEach((doc_matriz_riesgo) => {
                  db.collection("matriz_riesgo")
                    .doc(doc_matriz_riesgo.id)
                    .update({
                      em_id_cliente_iper: this.$store.state
                        .msp_c_key_cliente_iper,
                      em_fecha_editado: this.fecha_actualizado,
                    })
                    .then(() => { })
                    .catch((error) => {
                      console.error(
                        "Error al actualizar MATRIZ_RIESGO: ",
                        error
                      );
                    });
                });
              }
            })
            .catch((error) => {
              console.error(
                "Error al encontrar el tamaño del documento de MATRIZ_RIESGO: ",
                error
              );
            });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Datos actualizados correctamente.",
            showConfirmButton: false,
            timer: 1800,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            const tap1 = document.querySelector("#mmp-tab");
            tap1.classList.remove("active");
            tap1.setAttribute("aria-selected", false);
            this.control_cambio(this.$store.state.msp_c_key, fechaEditada);
            const tap2 = document.getElementById("msp-tab");
            tap2.setAttribute("aria-selected", true);
            this.$router.push("/seleccionar_proceso");
          });
        })
        .catch((error) => console.log("Error al editar...", error));
      }
    },

    limpiar_variables() {
      this.cliente = "";
      this.sector_cliente = "";
      this.id_cliente_iper = "";
      this.centro_trabajo = "";
      this.numero_expuestos = null;
      this.regional = "";
      this.pais_trabajo = "";
      this.departamento = "";
      this.municipio = "";
      // this.nombre_contacto = "";
      // this.cargo_contacto = "";
      // this.correo_contacto = "";
      // this.numero_contacto = "";
      this.direccion = "";
      this.coordenadas_encuesta = "";
    },

    limpiar_variables_globales() {
      this.$store.state.mip_id_proceso = "";
      this.$store.state.mip_id_zona = "";
      this.$store.state.mip_id_actividad = "";
      this.$store.state.mip_id_tareas = "";
      this.$store.state.mip_proceso = "";
      this.$store.state.mip_zona = "";
      this.$store.state.mip_actividad = "";
      this.$store.state.mip_tarea = [];
      this.$store.state.mip_rutinario = "";
      this.$store.state.global_id_matriz_riesgo = "";
      this.$store.state.global_es_editar = false;
      this.$store.state.global_nuevo_peligro = false;
      this.$store.state.msp_c_key = "";
    },

    terminar_centro_trabajo() {
      this.limpiar_variables();
      this.$store.commit("mutation_limpiar_globales");
    },

    regional_select() {
      this.lista_regionales = [];
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_registrado_por", "==", this.$store.state.email)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_regionales.push(doc.data().r_nueva_region);
              const set = new Set(this.lista_regionales.map(JSON.stringify));
              this.lista_regionales = Array.from(set).map(JSON.parse);
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          this.lista_regionales.push(x.nombre_regional);
        });
      }
    },

    departamento_select() {
      this.lista_departamentos = [];
      this.lista_municipios = [];
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regional)
          .where("r_registrado_por", "==", this.$store.state.email)
          .orderBy("r_departamento", "asc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_departamentos.push(doc.data().r_departamento);
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          if (x.nombre_regional == this.regional) {
            x.departamentos.forEach((y) => {
              this.lista_departamentos.push(y.nombre_departamento);
            });
          }
        });
      }
    },

    municipio_select() {
      this.lista_municipios = [];
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regional)
          .where("r_departamento", "==", this.departamento)
          .where("r_registrado_por", "==", this.$store.state.email)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_municipios = doc.data().r_municipios;
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          if (x.nombre_regional == this.regional) {
            x.departamentos.forEach((y) => {
              if (y.nombre_departamento == this.departamento) {
                this.lista_municipios = y.municipios;
              }
            });
          }
        });
      }
    },

    // FUNCIÓN CARGAR SELECT CLIENTE
    async cargar_clientes() {
      this.clientes_iper = [];
      await db.collection("cliente_principal").where("cl_estado", "==", "En Servicio").orderBy("cl_cliente").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.clientes_iper.push(doc.data().cl_cliente);
        });
      });
      let set = new Set(this.clientes_iper.map(JSON.stringify));
      this.clientes_iper = Array.from(set).map(JSON.parse);
    },

    // FUNCIÓN CONSULTAR CLIENTES POR NOMBRE
    async consultar_clientes_por_nombre() {
      if (!this.cliente) {
        this.id_cliente_iper = "";
        this.sector_cliente = "";
      }
      await db.collection("cliente_principal").where("cl_cliente", "==", this.cliente).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.id_cliente_iper = doc.id;
          this.sector_cliente = doc.data().cl_sector;
        });
      })
    },

    // FUNCIÓN CONSULTAR CLIENTES POR ID
    consultar_clientes_por_id(id) {
      let docRef = db.collection("cliente_principal").doc(id);
      docRef.get().then((doc) => {
        (this.cliente = `${doc.data().cl_cliente}`),
          (this.id_cliente_iper = id),
          (this.$store.state.msp_c_key_cliente_iper = id);
      });
    },

    consultar_regional(dpto) {
      db.collection("nuevo_regional")
        .where("r_departamento", "==", dpto)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.regional = doc.data().r_nueva_region;
            this.departamento_select();
            this.municipio_select();
          });
        });
    },

    // CONSULTAR Y EDITAR
    // FUNCIÓN PARA MOSTRAR DATOS MATRIZ DE PELIGROS
    consultar_matriz_peligros() {
      let docRef = db
        .collection("cliente_empresa")
        .doc(this.$store.state.msp_c_key);
      docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_id_cliente_principal) {
            this.consultar_clientes_por_id(
              `${doc.data().em_id_cliente_principal}`
            );
          } else {
            this.id_cliente_iper = null;
            this.$store.state.msp_c_key_cliente_iper = null;
          }
          this.departamento = doc.data().em_departamento;
          this.municipio = doc.data().em_ciudad;
          this.fecha_actualizado = doc.data().em_fecha_editado;
          if (doc.data().em_regional) {
            this.regional = doc.data().em_regional;
            this.departamento_select();
            this.municipio_select();
          } else {
            this.consultar_regional(`${doc.data().em_departamento}`);
          }
          if (doc.data().em_gps) {
            this.coordenadas_encuesta = doc.data().em_gps;
          }
          this.centro_trabajo = doc.data().em_trabajo;
          this.numero_expuestos = parseInt(doc.data().em_num_trabajadores, 10);
          this.$store.state.n_max_expuestos = parseInt(
            doc.data().em_num_trabajadores,
            10
          );
          this.pais_trabajo = doc.data().em_pais;
          if (doc.data().em_sector) {
            this.sector_cliente = doc.data().em_sector;
          } else {
            this.sector_cliente = null;
          }
          // this.nombre_contacto = doc.data().em_responsable;
          this.nombre_contacto = "Ángela Johana Gaitán López";
          if (doc.data().em_cargo) {
            // this.cargo_contacto = doc.data().em_cargo;
            this.cargo_contacto = "Gerente H&S";
            this.correo_contacto = "angela.gaitan@co.g4s.com";
            // this.correo_contacto = doc.data().em_correo_contacto;
            this.numero_contacto = 3212543320;
            // this.numero_contacto = doc.data().em_numero_contacto;
          } else {
            // this.cargo_contacto = '';
            this.cargo_contacto = "Gerente H&S";
            this.correo_contacto = "angela.gaitan@co.g4s.com";
            // this.correo_contacto = '';
            this.numero_contacto = 3212543320;
            // this.numero_contacto = '';
          }
          if (doc.data().em_direccion) {
            this.direccion = doc.data().em_direccion;
          } else {
            this.direccion = "";
          }
          // ALERTA CONSULTA
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Obteniendo datos.",
            showConfirmButton: false,
            timer: 1500,
          });
          // FIN ALERTA CONSULTA
        }
      });
    },

    // FUNCIÓN PARA MOSTRAR ID MATRIZ DE PELIGRO
    consultar_id_matriz_peligro(id_matriz_peligro) {
      let docRef = db.collection("matriz_peligro").doc(id_matriz_peligro);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.consul_key = `${doc.id}`;
          this.consul_matriz_peligro = `${doc.data().pe_cliente}`;
        }
      });
    },

    toggleIcon() {
      let iconClass = document.getElementById("icon-collapse");
      if (iconClass.classList) {
        iconClass.classList.toggle("fa-chevron-up");
      } else {
        var classes = iconClass.className.split(" ");
        var i = classes.indexOf("fa-chevron-down");
        if (i >= 0) classes.splice(i, 1);
        else classes.push("fa-chevron-up");
        iconClass.className = classes.join(" ");
      }
    },

    // CONTROL DE CAMBIOS
    async control_cambio(id, fecha) {
      this.controlCambioMatriz.controlCambios.fechaCambio = fecha;
      let collectionComentario = "cliente_empresa/" + id + "/controlcambios";
      let refControlCambios = db.collection(collectionComentario).doc();
      this.controlCambioMatriz.controlCambios.idControlCambio =
        refControlCambios.id;
      let datosControl = db
        .collection(collectionComentario)
        .doc(this.controlCambioMatriz.controlCambios.idControlCambio);
      datosControl.set(this.controlCambioMatriz).then(() => {
        // ALERTA GUARDADO
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Datos guardados correctamente.",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
  },
};
// PRIMERA LETRA EN MAYÚSCULA
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
</script>

<style scoped>
.btn_guardar {
  background-color: #ee8813 !important;
  color: #fff;
  border-radius: 15px;
}
</style>